import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MiniGameService } from 'src/app/pages/minigame/minigame.service';
import { ObLotteryService } from 'src/app/pages/obLottery/obLottery.service';
import { ConcatLeftmenu } from 'src/app/shared/interfaces/game.interface';
import { LocaleService } from 'src/app/shared/service/locale.service';

@Injectable({
  providedIn: 'root',
})
export class LeftMenuService {
  constructor(
    private miniGameService: MiniGameService,
    private localeService: LocaleService,
    private obLotteryService: ObLotteryService,
  ) {}

  LEFT_MENU_DATA = {
    main: [
      {
        name: this.localeService.getValue('sports'),
        ident: 'sport-main',
        icon: 'icon-tiyu',
        target: 'sports',
        page: 'play/FBSport-1',
      },
      {
        name: this.localeService.getValue('casino'),
        ident: 'casino-main',
        icon: 'icon-yulecheng',
        target: 'casino',
        page: 'casino',
      },
      {
        name: this.localeService.getValue('lottery'),
        ident: 'lottery-main',
        icon: 'icon-caipiao',
        target: 'lottery',
        page: 'lottery',
      },
    ],
    list: [
      {
        ident: 'sports',
        name: this.localeService.getValue('sports_event'),
        showOnRail: true,
        isRailMain: true,
        railPage: 'play/FBSport-1',
        railIcon: 'icon-tiyu',
        expand: true, //默认打开
        children: [
          //OB体育
          {
            name: this.localeService.getValue('ob_es'),
            ident: 'ob',
            page: 'play/OBSport-1',
            icon: 'icon-pm',
            class: 'bright',
            closeOnclick: true,
          },
          //IM体育
          {
            name: this.localeService.getValue('im_sport'),
            ident: 'imSport',
            page: 'play/IMSport-1',
            icon: 'icon-imSport',
            class: 'bright',
            closeOnclick: true,
          },
          //沙巴体育
          {
            name: this.localeService.getValue('sb_sport'),
            ident: 'saba',
            page: 'play/SaBaSport-1',
            icon: 'icon-sbtiyu',
            class: 'bright',
            closeOnclick: true,
          },
          //平博体育
          {
            name: this.localeService.getValue('sport_pingbo'),
            ident: 'pingbo',
            page: 'play/PinnacleSport-1',
            icon: 'icon-pingbo',
            class: 'bright',
            closeOnclick: true,
          },
          //FB体育
          {
            name: this.localeService.getValue('fb_sport'),
            ident: 'pingbo',
            page: 'play/FBSport-1',
            icon: 'icon-fb-sport',
            class: 'bright',
            closeOnclick: true,
          },
          //IM电竞
          {
            name: this.localeService.getValue('im_es'),
            ident: 'im',
            page: 'play/IMESport-2',
            icon: 'icon-im',
            class: 'bright',
            closeOnclick: true,
          },
          //平博电竞
          {
            name: this.localeService.getValue('pingbo_esport'),
            ident: 'pingboEsport',
            page: 'play/PinnacleSport-1/e-sports',
            icon: 'icon-pingbo-eSport',
            class: 'bright',
            closeOnclick: true,
          },
        ],
      },
      {
        ident: 'casino',
        name: this.localeService.getValue('casino'),
        showOnRail: true,
        isRailMain: true,
        railPage: 'casino/home/index',
        railIcon: 'icon-yulecheng',
        // expand: true, //默认打开
        children: [
          // {
          //   name: this.localeService.getValue('my_coll'),
          //   ident: 'casino-favorites',
          //   page: 'casino/favorites',
          //   icon: 'icon-heart',
          //   needLogined: true,
          // },
          // {
          //   name: this.localeService.getValue('all_rec'),
          //   ident: 'casino-history',
          //   page: 'casino/recentPlayed',
          //   icon: 'icon-history',
          //   needLogined: true,
          // },
        ],
      },
      // 彩票
      {
        ident: 'lottery',
        name: this.localeService.getValue('lottery'),
        showOnRail: true,
        isRailMain: true,
        railPage: 'lottery',
        railIcon: 'icon-caipiao',
        children: [
          {
            name: this.localeService.getValue('in_lott'),
            page: 'casino/category/' + this.obLotteryService.MENU_DATA[0],
            icon: 'icon-jikaicai',
          },
          {
            name: this.localeService.getValue('pk_ten'),
            page: 'casino/category/' + this.obLotteryService.MENU_DATA[1],
            icon: 'icon-pkshi',
          },
          {
            name: this.localeService.getValue('ssc'),
            page: 'casino/category/' + this.obLotteryService.MENU_DATA[2],
            icon: 'icon-shishicai',
          },
          {
            name: this.localeService.getValue('lotto'),
            page: 'casino/category/' + this.obLotteryService.MENU_DATA[3],
            icon: 'icon-shijiele',
          },
          {
            name: this.localeService.getValue('ele_five'),
            page: 'casino/category/' + this.obLotteryService.MENU_DATA[4],
            icon: 'icon-fivein11',
          },

          {
            name: this.localeService.getValue('k_three'),
            page: 'casino/category/' + this.obLotteryService.MENU_DATA[5],
            icon: 'icon-kuaisan',
          },
          {
            name: this.localeService.getValue('threed'),
            page: 'casino/category/' + this.obLotteryService.MENU_DATA[6],
            icon: 'icon-threed',
          },
          {
            name: this.localeService.getValue('keno'),
            page: 'casino/category/' + this.obLotteryService.MENU_DATA[7],
            icon: 'icon-kuailecai',
          },
          {
            name: this.localeService.getValue('shuanseqiu'),
            page: 'casino/category/' + this.obLotteryService.MENU_DATA[8],
            icon: 'icon-shuangse',
          },
          {
            name: this.localeService.getValue('wanzifour'),
            page: 'casino/category/' + this.obLotteryService.MENU_DATA[9],
            icon: 'icon-wanzifour',
          },
          {
            name: this.localeService.getValue('vnc'),
            page: 'casino/category/' + this.obLotteryService.MENU_DATA[10],
            icon: 'icon-yuenancai',
          },
          {
            name: this.localeService.getValue('shaibao'),
            page: 'casino/category/' + this.obLotteryService.MENU_DATA[11],
            icon: 'icon-shaibao',
          },
          {
            name: this.localeService.getValue('league_legends'),
            page: 'casino/category/' + this.obLotteryService.MENU_DATA[12],
            icon: 'icon-leaguelegends',
          },
          {
            name: this.localeService.getValue('dipin'),
            page: 'casino/category/' + this.obLotteryService.MENU_DATA[13],
            icon: 'icon-dipincai',
          },
        ],
      },
      // 棋牌
      {
        ident: 'chess',
        name: this.localeService.getValue('chess'),
        showOnRail: true,
        isRailMain: true,
        railIcon: 'icon-xxgame',
        children: [
          // 开元棋牌
          {
            name: this.localeService.getValue('ky_game'),
            page: 'play/KYChess-6',
            icon: 'icon-ky',
            closeOnclick: true,
          },
          // 博雅棋牌
          {
            name: this.localeService.getValue('boyachess'),
            page: 'play/BoyaChess-6',
            icon: 'icon-boya',
            closeOnclick: true,
          },
          // 双赢棋牌
          {
            name: this.localeService.getValue('sgwinchess'),
            page: 'play/SGWinChess-6',
            icon: 'icon-sgwinchess',
            closeOnclick: true,
          },
          // 高登棋牌
          {
            name: this.localeService.getValue('golden_chess'),
            page: 'play/Golden-6',
            icon: 'icon-gorden',
            closeOnclick: true,
          },
          // YY棋牌
          {
            name: this.localeService.getValue('yychess'),
            page: 'play/YYChess-6',
            icon: 'icon-yychess',
            closeOnclick: true,
          },
        ],
      },
      {
        name: this.localeService.getValue('new_coupon'),
        ident: 'latest-offers', //请勿修改
        page: 'promotions/offer',
        icon: '',
      },
      {
        name: this.localeService.getValue('online_cs'),
        ident: 'onLines', //请勿修改
        page: '',
        icon: '',
      },
      // {
      //   name: this.localeService.getValue('odds') + ':',
      //   ident: 'odds',
      //   options: [
      //     {
      //       select: undefined,
      //       ident: 'oddsFormat', //请勿修改
      //       class: 'theme-color',
      //       options: []
      //     },
      //     {
      //       select: undefined,
      //       ident: 'countrySelect', //请勿修改
      //       options: []
      //     }
      //   ]
      // },
      {
        //语言选择
        name: this.localeService.getValue('lang') + ':',
        ident: 'langSelect', //请勿修改
        showOnRail: true,
        icon: '',
        page: '',
        options: [
          {
            select: undefined,
            selectIcon: true,
            ident: 'langList',
            options: [],
          },
        ],
      },
      //日夜间版
      {
        showOnRail: true,
        special: true,
        ident: 'theme-switch',
      },
    ],
  };

  DEFAULT_MENU = [
    // {
    //   // 通知
    //   name: 'Notifications',
    //   ident: 'notifications',
    //   page: 'notification-center/home',
    //   showOnRail: true,
    //   menuIcon: 'fi-bell-filled',
    //   needLogined: true,
    //   isNotification: true,
    // },
    {
      // 促销
      // name: this.localeService.getValue('new_coupon'),
      name: 'Promotions',
      ident: 'latest-offers',
      showOnRail: true,
      menuIcon: 'fi-tag-filled',
      config: {
        assignUrl: '/promotions/offer',
      },
      redirectMethod: 'AssignUrl',
    },
    {
      name: 'Loyalty Program',
      ident: 'profile-vip',
      showOnRail: true,
      menuIcon: 'fi-vip-filled',
      config: {
        assignUrl: '/loyalty',
      },
      redirectMethod: 'AssignUrl',
    },
    {
      // 聊天室
      name: 'Chat',
      ident: 'chat',
      showOnRail: true,
      menuIcon: 'fi-chat-alt-2',
      isChat: true,
    },
    // {
    //   // 个人资料
    //   name: 'Profile',
    //   ident: 'profile',
    //   showOnRail: true,
    //   menuIcon: 'fi-user-filled',
    //   redirectMethod: 'DropDownList',
    //   expand: false,
    //   needLogined: true,
    //   infoExpandList: [
    //     // {
    //     //   name: 'Vault',
    //     //   ident: 'profile-vault',
    //     //   showOnRail: true,
    //     //   menuIcon: 'fi-vault-filled',
    //     // },
    //     {
    //       name: 'Funds',
    //       ident: 'profile-wallet',
    //       showOnRail: true,
    //       menuIcon: 'fi-cash',
    //       config: {
    //         assignUrl: '/settings/funds',
    //       },
    //       redirectMethod: 'AssignUrl',
    //     },
    //     {
    //       name: 'My Bonuses',
    //       ident: 'profile-bonuses',
    //       showOnRail: true,
    //       menuIcon: 'fi-gift-filled',
    //       config: {
    //         assignUrl: '/bonuses',
    //       },
    //       redirectMethod: 'AssignUrl',
    //     },
    //     // {
    //     //   name: 'Loyalty Program',
    //     //   ident: 'profile-vip',
    //     //   showOnRail: true,
    //     //   menuIcon: 'fi-vip-filled',
    //     //   config: {
    //     //     assignUrl: '/loyalty',
    //     //   },
    //     //   redirectMethod: 'AssignUrl',
    //     // },
    //     {
    //       name: 'Settings',
    //       ident: 'profile-settings',
    //       showOnRail: true,
    //       menuIcon: 'fi-gear-filled',
    //       config: {
    //         assignUrl: '/settings',
    //       },
    //       redirectMethod: 'AssignUrl',
    //     },
    //     {
    //       name: 'Transactions',
    //       ident: 'profile-transactions',
    //       showOnRail: true,
    //       menuIcon: 'fi-switch-horizontal-filled',
    //       config: {
    //         assignUrl: '/transactions',
    //       },
    //       redirectMethod: 'AssignUrl',
    //     },
    //     {
    //       name: 'Log Out',
    //       ident: 'profile-logOut',
    //       showOnRail: true,
    //       menuIcon: 'fi-logout-right-filled',
    //       needLogined: true,
    //       isLogout: true,
    //     },
    //   ],
    // },
    {
      // 日夜间版
      name: 'Mode',
      ident: 'theme-switch',
      showOnRail: true,
      menuIcon: 'fi-moon',
      special: true,
    },
    {
      // 支持
      name: 'Support',
      ident: 'support',
      showOnRail: true,
      menuIcon: 'fi-support-filled',
      redirectMethod: 'DropDownList',
      expand: false,
      infoExpandList: [
        {
          // 在线客服
          // name: this.localeService.getValue('online_cs'),
          name: 'Live Support',
          ident: 'onLines',
          showOnRail: true,
          menuIcon: 'fi-chat-filled',
          isCS: true,
        },
        {
          name: 'Help Center',
          ident: 'support-helpCenter',
          showOnRail: true,
          menuIcon: 'fi-map',
          isOtherPage: true,
        },
        // {
        //   name: 'FAQ',
        //   ident: 'support-faq',
        //   showOnRail: true,
        //   menuIcon: 'fi-faq-filled',
        //   config: {
        //     assignUrl: '/help-center/home',
        //   },
        //   redirectMethod: 'AssignUrl',
        // },
      ],
    },
    // {
    //   // 语言选择
    //   name: this.localeService.getValue('lang') + ':',
    //   ident: 'langSelect',
    //   showOnRail: true,
    //   menuIcon: 'fi-globe',
    //   page: '',
    //   options: [
    //     {
    //       select: undefined,
    //       selectIcon: true,
    //       ident: 'langList',
    //       options: [],
    //     },
    //   ],
    //   expand: false,
    //   special: true,
    // },
  ];

  //用于插入收藏数据
  getFavArr(favNum: BehaviorSubject<number>, collNum: BehaviorSubject<number>): ConcatLeftmenu[] {
    return [
      {
        name: 'My Favourites',
        ident: 'casino-favorites',
        menuIcon: 'fi-favourites-filled',
        config: {
          assignUrl: '/favorites',
        },
        redirectMethod: 'AssignUrl',
        num: favNum,
        scenesType: 'Expand',
        needLogined: true,
        showOnRail: true,
      },
      {
        name: 'Recently Played',
        ident: 'casino-history',
        menuIcon: 'fi-recently-played',
        config: {
          assignUrl: '/recentPlayed',
        },
        redirectMethod: 'AssignUrl',
        num: collNum,
        hasBotLine: true,
        scenesType: 'Expand',
        needLogined: true,
        showOnRail: true,
      },
    ];
  }

  /**
   * 判斷 menu item 是否應處於 active 狀態
   *
   * 採用「雙向前綴匹配」：
   *   - routePath 是 menuUrl 的子層 → menu 仍 highlight（往下導航）
   *   - routePath 是 menuUrl 的父層 → menu 仍 highlight（尚未到達目標層）
   *
   * @example
   * // menu url: /games/lobby/998
   * isActive('/games/lobby/998', '/games/lobby')         // ✅ 父層
   * isActive('/games/lobby/998', '/games/lobby/998')     // ✅ 完全相同
   * isActive('/games/lobby/998', '/games/lobby/998/v2')  // ✅ 子層
   * isActive('/games/lobby/998', '/games/lobby/556')     // ❌ 同層但不同路徑
   * isActive('/games/lobby/998', '/games/lobby/9989')    // ❌ 非完整 segment
   * @param {string} menuUrl   - menu item 對應的路徑
   * @param {string} routePath - 當前頁面的路徑
   * @returns {boolean} menu item 是否處於 active 狀態
   */
  isRouteActive(menuUrl: string, routePath: string): boolean {
    const check = (a: string, b: string) => a === b || b.startsWith(a + '/');
    const normalize = (p: string) => p.replace(/\/+$/, ''); // 移除結尾 /
    const menu = normalize(menuUrl);
    const route = normalize(routePath);
    return check(menu, route) || check(route, menu);
  }
}
